export default __webpack_public_path__ + "static/media/upcoming-banner-1.02cd8dfe.png";